const mapAddOns = (url) => {
  const MAP_URL = {
    "/accumulation-distribution": "ACCUMULATION_DISTRIBUTION",
    "/back-test-engine": "BACKTEST_ENGINE",
    "/custom-signal-pro": "CUSTOM_SIGNAL_PRO",
    "/custom-signal-pro-save": "CUSTOM_SIGNAL_PRO_SAVE",
    "/price-action-signals": "PRICE_ACTION",
    "/mean-reversal-signal": "MEAN_REVERSION",
    "/momentum-breakout": "MOMENTUM_TRADING",
    "/divergence": "DIVERGENCE_SIGNAL",
    "/dow-signals": "DOW_SIGNAL",
  };
  return MAP_URL[url];
};

export default () => {
  mapAddOns;
  return {
    mapAddOns,
  };
};
